import FormField from './field.js';

export default class DealerLeadCodes extends FormField {

    constructor(parent, el) {
        super(parent, el);
        this.data = {};
        this.url = el.dataset.url;
        this.location = el.dataset.dealerLocation;
        this.param = el.dataset.dealerParam;
        this.sales = this.input('sales') 
        this.service = this.input('service');
        if(this.location === 'field') {
            this.dealerInput = parent.el.querySelector(`[name="${this.param}"]`);
        }
        this.bind();
        this.populate();
    }

    bind() {
        if(this.location === 'hash') {
            window.addEventListener('hashchange', () => this.populate());
        }
        
        if(this.location === 'field') {
            this.dealerInput.addEventListener('change', () => this.populate());
        }
    }

    dealer(){
        if(this.location === 'hash') {
            return new URLSearchParams(window.location.hash.split("?")[1] || "").get(this.param);
        } else if(this.location === 'query') {
            return new URLSearchParams(window.location.search || "").get(this.param);
        } else if(this.location === 'field' && this.dealerInput) {
            return this.dealerInput.value;
        }
    }

    populate(){
        const dealer = this.dealer();
        if (!dealer) { return; }
        dealer === this.data?.uri ? this.set() : this.get(dealer);
    }   

    set() {
        if(this.data?.uri){
            const sales = this.data?.productServices?.find(ps => ps.code === "SALES")?.leadCode;
            const service = this.data?.productServices?.find(ps => ps.code === "SERVICE")?.leadCode;
            this.sales.el.value = sales || "";
            this.service.el.value = service || "";
        } else {
            this.reset();
        }
    }

    reset() {
        this.sales.el.value = "";
        this.service.el.value = "";
    }

    save(result) {
        this.data = result?.dealer;
    }
    
    get(dealer) {
        const data = new FormData();
        data.append('dealer', dealer);
        return fetch(this.url, { method: 'POST', body: data })
            .then((response) => response.json())
            .then((result) => this.save(result))
            .then(() => this.set())
            .catch(() => this.reset())
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_dealer_lead_codes');
    }
}